import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  insuranceList: {},
  insuranceById: {},
  loading: {
    create: false,
    read: false,
    update: false,
    delete: false,
    getById: false,
    deleteImage : false
  },
  error: false,
  errorMessage: "",
};

const insuranceSlice = createSlice({
  name: "insurance",
  initialState,
  reducers: {
    getInsuranceList(state, action) {
      state.insuranceList = action.payload;
      state.loading.read = false;
      state.error = null;
    },
    insuranceByIdData(state, action) {
      state.insuranceById = action.payload;
      state.loading.getById = false;
      state.error = null;
    },
    errorMessages(state, action) {
      state.errorMessage = action.payload;
      state.error = true;
    },
    hideErrorMessage(state) {
      state.error = false;
      state.errorMessage = "";
    },
    loadingData(state, action) {
      const { type, value } = action.payload;
      state.loading[type] = value;
    },
  },
});

export const {
  getInsuranceList,
  insuranceByIdData,
  errorMessages,
  loadingData,
  hideErrorMessage,
} = insuranceSlice.actions;

export default insuranceSlice.reducer;
